import React, { Component } from 'react';
import './App.scss';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import produce from 'immer';
import AdminPanel from './components/AdminPanel/AdminPanel';
import ContentTable from './components/AdminPanel/Content/ContentTable/ContentTable';
import ContentForm from './components/AdminPanel/Content/ContentForm/ContentForm';
import { stylingAPI } from './services/styling';


class App extends Component {

    state = {
        styling: null
    }

    render() {
        const styling = this.state.styling;
        if (!styling) {
            return null;
        }

        return(
            <>
                <div>
                    <style>
                        {
                            "\
                            .background{\
                                background: "+styling.background+"\
                            }\
                            .bg-secondary-color{\
                                background-color: "+styling.secondaryColor+"!important;\
                            }\
                            .border-secondary-color{\
                                border-color: "+styling.secondaryColor+"!important;\
                            }\
                            .primary-font{\
                                font-family:"+styling.primaryFont+";\
                            }\
                            .secondary-font{\
                                font-family:"+styling.secondaryFont+";\
                            }\
                            .primary-color{\
                                color:"+styling.primaryColor+"!important;\
                            }\
                            .secondary-color{\
                                color:"+styling.secondaryColor+"!important;\
                            }\
                            .tertiary-color{\
                                color:"+styling.tertiaryColor+"!important;\
                            "
                        }
                    </style>
                </div>
                
                <div className="primary-font secondary-font">
                    <AdminPanel styling={styling}>
                        <Switch>
                            <Route exact path="/portal/content/:id">
                                <ContentForm styling={styling}/>
                            </Route>
                            <Route exact path="/portal/content/new">
                                <ContentForm styling={styling}/>
                            </Route>

                            <Route exact path="/portal/content">
                                <ContentTable styling={styling}/>
                            </Route>
                            
                            <Route render={() => <Redirect to="/portal/content" />} />
                        </Switch>
                    </AdminPanel>
                </div>
            </>
        );
    }

    componentDidMount() {
        stylingAPI.getStyles()
            .then(styling=>{
                if (!styling) {
                    return;
                }
                this.setState(
                    produce(draft => {
                        draft.styling = styling;
                    })
                );
            });
    }

}

export default App;
